import { Injectable, inject } from '@angular/core';
import { CommonIP } from '@model/ftf-api.model';
import { Store } from '@ngrx/store';
import * as FavoritesActions from '@store/actions/favorites.actions';
import { selectFavoriteItems } from '@store/selectors/favorites.selectors';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FavoriteService {
  private store = inject(Store);

  favoriteItems$: Observable<CommonIP[]> = this.store.select(selectFavoriteItems);

  /**
   * Saves a favorite object to the user's favorite items.
   *
   * @param {CommonIP} favoriteObject - The favorite object to be saved.
   * @returns {boolean} - Returns true if the operation was dispatched successfully, false otherwise.
   */
  saveFavorite(favoriteObject: CommonIP): boolean {
    this.store.dispatch(FavoritesActions.addFavoriteItem({ favorite: favoriteObject }));
    return true;
  }

  removeFavorite(favoriteObject: CommonIP) {
    this.store.dispatch(FavoritesActions.removeFavoriteItem({ favorite: favoriteObject }));
  }

  /**
   * Loads the previous favorite for the current user and updates the favorite items.
   */
  loadPreviousFavorite() {
    this.store.dispatch(FavoritesActions.loadFavorites());
  }

}
